var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: -5.4,
    y: 44.7,
    width: 43.4,
    height: 64.2,
    transform: "translate(-34.2 16.7) rotate(-28.1)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3,27.6v-15c0-.6-.5-1.1-1-1.1H7.6c-.6,0-1,.5-1,1.1v15",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2.6 28 17.5 28 17.5 28.5 22.4 28.5 22.4 28 37.3 28 37.1 30.5 2.6 30.5 2.6 28",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,16.3s-2,0-2.7,1.8,2.7,6.2,2.7,6.2c0,0,3.7-3.7,2.7-6.2s-2.7-1.8-2.7-1.8",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.9,
    cy: 19.2,
    r: 0.9,
    style: {
      fill: "#0194d3"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackIcon);
export default __webpack_public_path__ + "static/media/track-icon.7cfd35c68d206c6bd795de9cc83f6fc9.svg";
export { ForwardRef as ReactComponent };